<!-- ============== HERO ============== -->
<section class="hero">
  <a class="ciopora" href="https://www.ciopora.org/supporters" target="_blank" rel="noopener"
     [attr.aria-label]="'hero.cioporaAlt' | translate">
    <img src="assets/img/home/logo-ciopora.png" [alt]="'hero.cioporaAlt' | translate">
  </a>

  <div class="content">
    <span class="pill">{{ 'hero.pill' | translate }}</span>
    <h1>GESVATEC <span class="accent">PackCert</span></h1>
    <p class="lead" [innerHTML]="'hero.leadHtml' | translate"></p>
    <div class="ctas">
      <button class="btn btn-primary" type="button" (click)="openCorporateVideo()">
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
        {{ 'hero.videoBtn' | translate }}
      </button>
      <a href="#video" class="btn btn-ghost">{{ 'hero.discoverBtn' | translate }}</a>
      <a href="#blockchain" class="btn btn-ghost">{{ 'hero.blockchainBtn' | translate }}</a>
    </div>
  </div>
</section>

<!-- ============== INTRO / EVOLUCIÓN ============== -->
<section class="intro" id="evolucion">
  <div class="copy">
    <span class="eyebrow">{{ 'intro.eyebrow' | translate }}</span>
    <h2 [innerHTML]="'intro.titleHtml' | translate"></h2>
    <p [innerHTML]="'intro.p1Html' | translate"></p>
    <p [innerHTML]="'intro.p2Html' | translate"></p>
    <p [innerHTML]="'intro.p3Html' | translate"></p>
  </div>
  <div class="visual">
    <img src="assets/img/home/obtentor_01.jpg" [alt]="'intro.imgAlt' | translate">
  </div>
</section>

<!-- ============== VIDEO FEATURED ============== -->
<section class="video-section" id="video">
  <span class="eyebrow">{{ 'video.eyebrow' | translate }}</span>
  <h2 class="section-title" [innerHTML]="'video.titleHtml' | translate"></h2>
  <p class="section-lead center">{{ 'video.lead' | translate }}</p>

  <div class="video-frame" #videoFrame (click)="playVideo()">
    <ng-container *ngIf="!playing">
      <img class="thumb" src="assets/img/home/gesvatec_PackCert_01.jpg" alt="GESVATEC PackCert">
      <div class="play" [attr.aria-label]="'hero.videoBtn' | translate"></div>
      <span class="label">{{ 'video.label' | translate }}</span>
    </ng-container>
    <iframe *ngIf="videoUrl as url" [src]="url"
            title="Vídeo corporativo GESVATEC PackCert"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </div>
</section>

<!-- ============== 3 FORMAS DE IDENTIFICAR ============== -->
<section class="three-ways" id="identificacion">
  <span class="eyebrow">{{ 'ways.eyebrow' | translate }}</span>
  <h2 class="section-title" [innerHTML]="'ways.titleHtml' | translate"></h2>
  <p class="section-lead center">{{ 'ways.lead' | translate }}</p>

  <div class="ways-grid">
    <div class="way-card">
      <span class="way-num">01</span>
      <img class="way-img" src="assets/img/home/etiqueta_01.jpg" [alt]="'ways.c1Alt' | translate">
      <h3>{{ 'ways.c1Title' | translate }}</h3>
      <p>{{ 'ways.c1Text' | translate }}</p>
      <span class="tag">{{ 'ways.c1Tag' | translate }}</span>
      <div class="way-more-row">
        <a class="way-more" routerLink="/etiqueta">{{ 'ways.c1More' | translate }}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>
        </a>
      </div>
    </div>
    <div class="way-card">
      <span class="way-num">02</span>
      <img class="way-img cert" src="assets/img/certificado/certificado_nadorcott_V4.png" [alt]="'ways.c2Alt' | translate">
      <h3>{{ 'ways.c2Title' | translate }}</h3>
      <p>{{ 'ways.c2Text' | translate }}</p>
      <span class="tag">{{ 'ways.c2Tag' | translate }}</span>
      <div class="way-more-row">
        <a class="way-more" routerLink="/certificado">{{ 'ways.c2More' | translate }}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>
        </a>
      </div>
    </div>
    <div class="way-card">
      <span class="way-num">03</span>
      <img class="way-img" src="assets/img/home/etiqueta_certificado_01.webp" [alt]="'ways.c3Alt' | translate">
      <h3>{{ 'ways.c3Title' | translate }}</h3>
      <p>{{ 'ways.c3Text' | translate }}</p>
      <span class="tag">{{ 'ways.c3Tag' | translate }}</span>
    </div>
  </div>
</section>

<!-- ============== FEATURES ============== -->
<section class="features" id="caracteristicas">
  <span class="eyebrow">{{ 'features.eyebrow' | translate }}</span>
  <h2 class="section-title" [innerHTML]="'features.titleHtml' | translate"></h2>
  <p class="section-lead center">{{ 'features.lead' | translate }}</p>

  <div class="features-grid">
    <article class="feature">
      <div class="icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 2 4 6v6c0 5 3.5 9.5 8 10 4.5-.5 8-5 8-10V6l-8-4z"/></svg>
      </div>
      <h3>{{ 'features.f1Title' | translate }}</h3>
      <p>{{ 'features.f1Text' | translate }}</p>
    </article>

    <article class="feature">
      <div class="icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 12l2 2 4-4"/><rect x="3" y="3" width="18" height="18" rx="3"/></svg>
      </div>
      <h3>{{ 'features.f2Title' | translate }}</h3>
      <p>{{ 'features.f2Text' | translate }}</p>
    </article>

    <article class="feature">
      <div class="icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M3 12h18M3 6h18M3 18h12"/></svg>
      </div>
      <h3>{{ 'features.f3Title' | translate }}</h3>
      <p>{{ 'features.f3Text' | translate }}</p>
    </article>

    <article class="feature">
      <div class="icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="4" y="4" width="6" height="6" rx="1"/><rect x="14" y="4" width="6" height="6" rx="1"/><rect x="9" y="14" width="6" height="6" rx="1"/><path d="M10 7h4M7 10v4M17 10v4"/></svg>
      </div>
      <h3>{{ 'features.f4Title' | translate }}</h3>
      <p>{{ 'features.f4Text' | translate }}</p>
    </article>

    <article class="feature">
      <div class="icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M4 12h16M12 4v16M6 6l12 12M18 6L6 18"/></svg>
      </div>
      <h3>{{ 'features.f5Title' | translate }}</h3>
      <p>{{ 'features.f5Text' | translate }}</p>
    </article>

    <article class="feature">
      <div class="icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
      </div>
      <h3>{{ 'features.f6Title' | translate }}</h3>
      <p>{{ 'features.f6Text' | translate }}</p>
    </article>
  </div>
</section>

<!-- ============== BLOCKCHAIN ============== -->
<section class="blockchain" id="blockchain">
  <div class="grid">
    <div class="visual" aria-hidden="true"></div>
    <div class="copy">
      <span class="eyebrow">{{ 'blockchain.eyebrow' | translate }}</span>
      <h2 [innerHTML]="'blockchain.titleHtml' | translate"></h2>
      <p [innerHTML]="'blockchain.pHtml' | translate"></p>
      <ul class="checks">
        <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12l5 5L20 7"/></svg> {{ 'blockchain.check1' | translate }}</li>
        <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12l5 5L20 7"/></svg> {{ 'blockchain.check2' | translate }}</li>
        <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12l5 5L20 7"/></svg> {{ 'blockchain.check3' | translate }}</li>
        <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12l5 5L20 7"/></svg> {{ 'blockchain.check4' | translate }}</li>
      </ul>
    </div>
  </div>
</section>

<!-- ============== FLUJO ============== -->
<section class="flow" id="flujo">
  <span class="eyebrow">{{ 'flow.eyebrow' | translate }}</span>
  <h2 class="section-title" [innerHTML]="'flow.titleHtml' | translate"></h2>
  <p class="section-lead center" [innerHTML]="'flow.leadHtml' | translate"></p>

  <div class="flow-steps">
    <div class="flow-step">
      <div class="img-wrap"><img src="assets/img/home/planta_01.jpg" [alt]="'flow.s1Alt' | translate"></div>
      <div class="body">
        <div class="step-num">{{ 'flow.s1Step' | translate }}</div>
        <h3>{{ 'flow.s1Title' | translate }}</h3>
        <p>{{ 'flow.s1Text' | translate }}</p>
      </div>
    </div>
    <div class="flow-step">
      <div class="img-wrap"><img src="assets/img/home/confeccion_01.jpeg" [alt]="'flow.s2Alt' | translate"></div>
      <div class="body">
        <div class="step-num">{{ 'flow.s2Step' | translate }}</div>
        <h3>{{ 'flow.s2Title' | translate }}</h3>
        <p>{{ 'flow.s2Text' | translate }}</p>
      </div>
    </div>
    <div class="flow-step">
      <div class="img-wrap"><img src="assets/img/home/expedicion_02.jpg" [alt]="'flow.s3Alt' | translate"></div>
      <div class="body">
        <div class="step-num">{{ 'flow.s3Step' | translate }}</div>
        <h3>{{ 'flow.s3Title' | translate }}</h3>
        <p>{{ 'flow.s3Text' | translate }}</p>
      </div>
    </div>
    <div class="flow-step">
      <div class="img-wrap"><img src="assets/img/home/expedicion_01.jpg" [alt]="'flow.s4Alt' | translate"></div>
      <div class="body">
        <div class="step-num">{{ 'flow.s4Step' | translate }}</div>
        <h3>{{ 'flow.s4Title' | translate }}</h3>
        <p>{{ 'flow.s4Text' | translate }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ============== ROLES / BENEFICIARIOS ============== -->
<section class="roles" id="roles">
  <span class="eyebrow">{{ 'roles.eyebrow' | translate }}</span>
  <h2 class="section-title" [innerHTML]="'roles.titleHtml' | translate"></h2>
  <p class="section-lead center">{{ 'roles.lead' | translate }}</p>

  <div class="roles-grid">
    <div class="role">
      <div class="role-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v20M5 8c0 3 7 4 7 4s7-1 7-4-7-4-7-4-7 1-7 4z"/></svg></div>
      <h3>{{ 'roles.r1Title' | translate }}</h3>
      <p>{{ 'roles.r1Text' | translate }}</p>
    </div>
    <div class="role">
      <div class="role-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 21h18M5 21V8l7-5 7 5v13M9 12h2M13 12h2M9 16h2M13 16h2"/></svg></div>
      <h3>{{ 'roles.r2Title' | translate }}</h3>
      <p>{{ 'roles.r2Text' | translate }}</p>
    </div>
    <div class="role">
      <div class="role-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 10h18M7 6V4M17 6V4"/></svg></div>
      <h3>{{ 'roles.r3Title' | translate }}</h3>
      <p>{{ 'roles.r3Text' | translate }}</p>
    </div>
    <div class="role">
      <div class="role-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 17h4V5H2v12h3"/><path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5v8h1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg></div>
      <h3>{{ 'roles.r4Title' | translate }}</h3>
      <p>{{ 'roles.r4Text' | translate }}</p>
    </div>
  </div>
</section>

<!-- ============== PRESENCIA / MAPA ============== -->
<section class="presence" id="presencia">
  <div class="copy">
    <span class="eyebrow">{{ 'presence.eyebrow' | translate }}</span>
    <h2 class="section-title" [innerHTML]="'presence.titleHtml' | translate"></h2>
  </div>
  <div class="map-card">
    <img src="assets/img/world-presence.svg" [alt]="'presence.alt' | translate">
  </div>
</section>

<!-- ============== CIFRAS ============== -->
<section class="stats">
  <span class="eyebrow">{{ 'stats.eyebrow' | translate }}</span>
  <h2 [innerHTML]="'stats.titleHtml' | translate"></h2>
  <div class="stats-grid">
    <div class="stat"><span class="num">{{ 'stats.s1Num' | translate }}</span><span class="label">{{ 'stats.s1Label' | translate }}</span></div>
    <div class="stat"><span class="num">{{ 'stats.s2Num' | translate }}</span><span class="label">{{ 'stats.s2Label' | translate }}</span></div>
    <div class="stat"><span class="num">{{ 'stats.s3Num' | translate }}</span><span class="label">{{ 'stats.s3Label' | translate }}</span></div>
    <div class="stat"><span class="num">{{ 'stats.s4Num' | translate }}</span><span class="label">{{ 'stats.s4Label' | translate }}</span></div>
    <div class="stat"><span class="num">{{ 'stats.s5Num' | translate }}</span><span class="label">{{ 'stats.s5Label' | translate }}</span></div>
    <div class="stat"><span class="num">{{ 'stats.s6Num' | translate }}</span><span class="label">{{ 'stats.s6Label' | translate }}</span></div>
    <div class="stat"><span class="num">{{ 'stats.s7Num' | translate }}</span><span class="label">{{ 'stats.s7Label' | translate }}</span></div>
  </div>
</section>

<!-- ============== CLIENTES (banda de logos) ============== -->
<section class="clients">
  <span class="eyebrow">{{ 'clients.eyebrow' | translate }}</span>
  <h2 class="section-title">{{ 'clients.title' | translate }}</h2>
  <div class="clients-marquee">
    <div class="clients-track">
      <img *ngFor="let logo of clientLogos" [src]="logo.src" [class.sm]="logo.sm" alt="">
      <img *ngFor="let logo of clientLogos" [src]="logo.src" [class.sm]="logo.sm" alt="" aria-hidden="true">
    </div>
  </div>
</section>

<!-- ============== CTA FINAL ============== -->
<section class="cta-final" id="contacto">
  <h2 [innerHTML]="'cta.titleHtml' | translate"></h2>
  <p>{{ 'cta.p' | translate }}</p>
  <div class="ctas">
    <button class="btn btn-primary" type="button" (click)="openDemo()">{{ 'cta.demoBtn' | translate }}</button>
  </div>
</section>

<!-- ============== MODAL VÍDEO CORPORATIVO ============== -->
<div class="video-modal" [class.open]="corpOpen" (click)="closeCorporateVideo($event)">
  <button class="close" type="button" (click)="closeCorporateVideo()" aria-label="Cerrar">×</button>
  <iframe *ngIf="corpUrl as url" [src]="url"
          title="Vídeo corporativo GESVATEC PackCert"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
</div>
